import React from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export const AttentionIcon: React.FC<AttentionIconProps> = ({ size = 16, fillColor }) => {
  const { colors } = useTheme()

  return (
    <Svg width={size} height={size} viewBox='0 0 16 16' fill='none'>
      <Path
        fill={fillColor || colors.iconWarning}
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.00332 8.74609C7.59094 8.74609 7.25664 8.41179 7.25664 7.99941L7.25664 5.34455C7.25664 4.93216 7.59094 4.59786 8.00332 4.59786C8.4157 4.59786 8.75 4.93216 8.75 5.34455L8.75 7.99941C8.75 8.41179 8.4157 8.74609 8.00332 8.74609Z'
      />
      <Path
        fill={fillColor || colors.iconWarning}
        fillRule='evenodd'
        d='M8.75 10.6537C8.75 11.0661 8.4157 11.4004 8.00332 11.4004L7.99668 11.4004C7.5843 11.4004 7.25 11.0661 7.25 10.6537C7.25 10.2413 7.5843 9.90703 7.99668 9.90703L8.00332 9.90703C8.4157 9.90703 8.75 10.2413 8.75 10.6537Z'
        clipRule='evenodd'
      />
      <Path
        stroke={fillColor || colors.iconWarning}
        strokeWidth={1.5}
        d='M8.95703 1.14648C8.46141 0.650884 7.67715 0.619934 7.14551 1.05371L7.04297 1.14648L1.14648 7.04297C0.650885 7.53859 0.619934 8.32285 1.05371 8.85449L1.14648 8.95703L7.04297 14.8535C7.53859 15.3491 8.32285 15.3801 8.85449 14.9463L8.95703 14.8535L14.8535 8.95703C15.3491 8.46141 15.3801 7.67715 14.9463 7.14551L14.8535 7.04297L8.95703 1.14648Z'
      />
    </Svg>
  )
}

type AttentionIconProps = {
  size?: number
  fillColor?: string
}
